export default "__VITE_ASSET__a28b029d__"